<template>
    <div class="col-12">
        <!--loader - message--->
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <!---------------step1-----------------------> 
        <div class="proMember mb-5 text-center " v-if="show_step == 1">
            <div class="mainTitle text-center mt-4 mb-5">
                <h3 class="mb-2"> {{$t('proTrader')}}</h3>   
                <p class="mb-4"> {{$t('proTraderText')}}</p>  
            </div>
            <!--  <p class="mb-4">{{$t('orderApply')}}</p> -->
           <div class="followProSteps d-flex justify-content-center" v-if="!become_pro">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">{{$t('tradingActivity')}}</h5>
                    <p class="card-text"><feather type="chevron-left" class="mr-2"></feather> {{$t('providetrades')}}</p>
                    <p class="card-text"><feather type="chevron-left" class="mr-2"></feather> {{$t('Screenshot')}}</p>
                    <p class="card-text"><feather type="chevron-left" class="mr-2"></feather> {{$t('AccountStat')}}</p>
                    <p class="card-text"><feather type="chevron-left" class="mr-2"></feather> {{$t('thirtParty')}}</p>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">{{$t('professionalExper')}}</h5>
                    <p class="card-text"><feather type="chevron-left" class="mr-2"></feather> {{$t('evidenceProf')}}</p>
                    <p class="card-text"><feather type="chevron-left" class="mr-2"></feather> {{$t('linkedIn')}}</p>
                    <p class="card-text"><feather type="chevron-left" class="mr-2"></feather> {{$t('businessCard')}}</p>
                    <p class="card-text"><feather type="chevron-left" class="mr-2"></feather> {{$t('CV')}}</p>
                    <p class="card-text"><feather type="chevron-left" class="mr-2"></feather> {{$t('payslip')}}</p>
                    <p class="card-text"><feather type="chevron-left" class="mr-2"></feather> {{$t('officialDoc')}}</p>
                  </div>
                </div>
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title">{{$t('eurnetWorth')}}</h5>
                    <p class="card-text"><feather type="chevron-left" class="mr-2"></feather> {{$t('evidenceliquid')}}</p>
                    <p class="card-text"><feather type="chevron-left" class="mr-2"></feather> {{$t('touchevidence')}}</p>
                  </div>
                </div>
           </div>

            <div class="row d-flex align-items-center justify-content-center" v-else>

                <div class="col-3">
                    <div class=" step1 radius whitebox p-4" :class="(select_doc_type.indexOf('fin_trans') != -1)? 'selected' : ''"> 
                        <label class="customRadio-button" for="checkbox_id"> 
                            <input type="checkbox" v-model="select_doc_type" value="fin_trans" id="checkbox_id">
                            <span class="checkmark"></span>
                        </label>
                        <h4 class="mb-3" for="checkbox_id"> {{$t('finTransa')}}</h4>
                        <p for="checkbox_id"> {{$t('finTransaText')}}</p>

                    </div>
                </div>
				<div class="col-3">
                    <div class=" step1 radius whitebox p-4" :class="(select_doc_type.indexOf('prof_exp') != -1)? 'selected' : ''">
                        <label class="customRadio-button"> 
                            <input type="checkbox" v-model="select_doc_type" value="prof_exp">
                            <span class="checkmark"></span>
                        </label>
                        <h4 class="mb-3"> {{$t('proExp')}}</h4>
                        <p> {{$t('proExpText')}}</p>
                    </div>
                </div>
                <div class="col-3">
                    <div class=" step1 radius whitebox p-4" :class="(select_doc_type.indexOf('fin_market') != -1)? 'selected' : ''">
                        <label class="customRadio-button"> 
                            <input type="checkbox" v-model="select_doc_type" value="fin_market">
                            <span class="checkmark"></span>
                        </label>
                        <h4 class="mb-3"> {{$t('finPort')}}</h4>
                        <p> {{$t('finPortText')}}</p>
                    </div>
                </div>
                
            </div>
             <a href="#" class="prism_btn btn_sm"  @click="become_pro = true " v-if="!become_pro">{{$t('clickPro')}}</a> 
            <div class="col-12 mt-5 probtn" v-if="become_pro">
                <a href="#" class="prism_btn btn_sm" :class="(select_doc_type.length < 1)? 'disabled' : ''" v-if="select_doc_type.length < 1"> {{$t('Continue')}}</a>
                <a href="#" class="prism_btn btn_sm" :class="(select_doc_type.length < 1)? 'disabled' : ''" @click="show_step_func()" v-else> {{$t('Continue')}}</a>
            </div>
			
        </div>

        <!---------------step2----------------------->
        <div  v-if="show_step == 2">
            <div class="mainTitle text-center mt-4 mb-3">
                <h3 class="mb-4"> {{$t('warning')}}</h3>  
            </div>
            <div class="CustomBlockWidth middleBox agreeConfrimBox  inMiddle-area whitebox p-4 mb-5 mt-2">
                <div class="scrollbar height65">
                        <p> {{$t('proMsz1')}}</p> 
                        <p> {{$t('proMsz2')}}: {{currentDate()}}</p> 
                         
                        <p>{{$t('proMsz3')}}:  <strong>{{get_user.profile.firstname}} {{get_user.profile.lastname}}</strong></p> 
                        <!-- <p>Account Number <strong>(“my Account”):</strong></p>  -->
                        <p>{{$t('emailaddress')}}: <strong>{{get_user.email}}</strong></p> 
                        <span v-html="$t('proMsz4')"> </span>
                </div>
                <div class="d-flex justify-content-between align-items-center border-top pt-3">
                    <div class="form-group field-wrapper mb-2">
                        <label class="text-left fancy_radiochk_btn d-flex align-items-center mb-0"> {{$t('proMsz17')}}
                            <input type="checkbox" v-model="agree" :value="1"><span class="checkmark"></span>
                        </label>
                    </div>
					<a href="#" class="underline mr-3" @click="show_step = 1">Back</a>
                    <a href="#" class="prism_btn btn_sm" :class="(agree == '')? 'disabled' : ''" v-if="agree == ''">{{$t('Continue')}} </a>
                    <a href="#" class="prism_btn btn_sm" :class="(agree == '')? 'disabled' : ''" @click="show_step = 3" v-else>{{$t('Continue')}}</a>
                </div>
            </div>
			
        </div>

        <!---------------step3----------------------->
        <div  v-if="show_step == 3">
            <div class="mainTitle text-center mt-4 mb-3">
                <h3 class="mb-2"> {{$t('uploadDoc')}}</h3>  
                <p class="mb-4">{{$t('uploadDocText')}} </p>
            </div>
            <div class="CustomBlockWidth middleBox  inMiddle-area whitebox p-4"> 
                <div class="justify-content-center" v-if="trans_id == ''  && !congModule"> 
                    <form action="" method="post" enctype="multipart/form-data" id="requestForm" v-on:submit.prevent="submitNow()">
                        <div class="promemberDocument">
                            <div class="row d-flex align-items-center justify-content-between mb-3 mb-3 border-bottom pb-5" v-if="select_doc_type.indexOf('fin_trans') >= 0">
                                <div class="col-9">
                                    <strong> {{$t('finTransa')}}</strong>
                                    <p class="mt-2">{{$t('proMsz5')}} </p>
                                </div>
                                <div class="col-3 box">
                                    <input type="file" name="document[]"  class="inputfile inputfile-1 form-control" id="fin_trans" @change="onFileChange('fin_trans', $event.target.files)"/>
                                    <label for="file-1">
                                         <feather type="upload" size="1.5em"></feather> 
                                         <span>{{$t('chooseFile')}} </span><!--  v-if="document_proof_array.fin_trans == ''" -->
                                    </label>
                                </div>
                                <div class="linerUpload prouploadedDoc w-100 d-flex align-items-center my-2 col-12" v-for="files,index in document_file_array['fin_trans']">
                                    <span class="nameIco">
                                        {{files.name}} 
                                    </span>
                                    <a href="#" class="closeBtn" @click="document_file_array['fin_trans'].splice(index, 1)"><feather type="x" size="1.5em" ></feather></a>
                                </div>
                            </div>
                            <div class="row d-flex align-items-center justify-content-between mb-3 border-bottom pb-3" v-if="select_doc_type.indexOf('fin_market') >= 0">
                                <div class="col-9">
                                    <strong> {{$t('finPort')}}</strong>
                                    <p class="mt-2">{{$t('proMsz6')}}  </p>
                                </div>
                                <div class="col-3 box">
                                    <input type="file" name="document[]"  class="inputfile inputfile-1 form-control" id="fin_market" @change="onFileChange('fin_market', $event.target.files)"/>
                                    <label for="file-1">
                                         <feather type="upload" size="1.5em"></feather> 
                                         <span>{{$t('chooseFile')}} </span>
                                    </label>
                                </div>
                                <div class="linerUpload prouploadedDoc w-100 d-flex align-items-center my-2 col-12" v-for="files,index in document_file_array['fin_market']">
                                    <span class="nameIco">{{files.name}}</span>
                                    <a href="#" class="closeBtn" @click="document_file_array['fin_market'].splice(index, 1)">
                                        <feather type="x" size="1.5em" ></feather>
                                    </a>
                                </div>
                            </div>
                            <div class="row d-flex align-items-center justify-content-between mb-5 border-bottom pb-3" v-if="select_doc_type.indexOf('prof_exp') >= 0">
                                <div class="col-9">
                                    <strong> {{$t('proExp')}}</strong>
                                    <p class="mt-2">{{$t('proMsz7')}} </p>
                                </div>
                                <div class="col-3 box">
                                    <input type="file" name="document[]" class="inputfile inputfile-1 form-control" id="prof_exp" @change="onFileChange('prof_exp', $event.target.files)"/>
                                    <label for="file-1">
                                         <feather type="upload" size="1.5em"></feather> 
                                         <span>{{$t('chooseFile')}} </span>
                                    </label>
                                </div>
                                <div class="linerUpload prouploadedDoc w-100 d-flex align-items-center my-2 col-12" v-for="files,index in document_file_array['prof_exp']">
                                    <span class="nameIco">
                                        {{files.name}}
                                    </span>
                                    <a href="#" @click="document_file_array['prof_exp'].splice(index, 1)" class="closeBtn"> <feather type="x" size="1.5em"></feather></a>
                                </div>
                            </div>
                            <div class="text-center d-flex align-items-center justify-content-between">
                                <a href="#" class="underline mr-3" @click="handleBack">Back</a>
                                <button class="prism_btn btn_sm" >{{$t('Continue')}} </button>         
                            </div> 
                        </div>
                    </form>
					
                </div>
            </div> 
			
        </div>

        <!---------------step4----------------------->
        <div  v-if="show_step == 4">
            <div class="mainTitle text-center mt-4 mb-3">
                <h3 class="mb-4"> {{$t('declaration')}}</h3>  
            </div>
            <div class="CustomBlockWidth middleBox agreeConfrimBox  inMiddle-area whitebox p-4 mb-5 mt-2">
                <div class="scrollbar height65">
                        <p>{{currentDate()}}</p>
						
                        <p>{{$t('proMsz10')}}</p>
                        <p> {{$t('proMsz11')}} {{get_user.profile.firstname}} {{get_user.profile.lastname}} {{$t('proMszHereClient')}} </p>
						
						<span v-html="$t('proMsz13')"></span>
                         
						
						<p v-if="select_doc_type.indexOf('fin_trans') >= 0">- {{$t('firstQuesMsz')}}.</p>
                        <p v-if="select_doc_type.indexOf('fin_market') >= 0">- {{$t('proMsz8')}}.</p>
                        <p v-if="select_doc_type.indexOf('prof_exp') >= 0">- {{$t('proMsz9')}}.</p>
						
						<span v-html="$t('proMsz14')"></span>
                         
                </div>
                <div class="d-flex justify-content-between align-items-center border-top pt-3">
                    <!-- <p>Enter {{$t('proMsz15')}}:  -->
                        <!-- <strong>{{get_user.profile.firstname}} {{get_user.profile.lastname}}</strong> -->
                    <div class="col-12 col-md-4">
                        <div class="form-group field-wrapper">
                            <input placeholder=" " type="text" v-model="f_name"  v-validate="'required'" name="First Name" class="float-field form-control"  :class="{ 'is-invalid': submittedRequest && errors.has('First Name') }"  />
                            <label for="password" class="float-label">{{$t('fname')}}<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('First Name')">{{ error }}</p> 
							<p class="error" v-if="errorMsz != ''">{{errorMsz}}</p>							
                        </div>
                    </div>
                    <div class="col-12 col-md-4">
                        <div class="form-group field-wrapper"> 
                            <input placeholder=" " type="text" v-model="l_name" class="float-field form-control" v-validate="'required'" name="Last Name"  :class="{ 'is-invalid': submittedRequest && errors.has('Last Name') }"  />
                            <label for="password"  class="float-label">{{$t('lname')}}<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('Last Name')">{{ error }}</p> 
							<p class="error" v-if="errorMsz1 != ''">{{errorMsz1}}</p>							
                        </div>
                    </div>
				</div>
				  
                <div class="d-flex justify-content-between align-items-center border-top pt-3">
                    <div class="form-group field-wrapper mb-2">
                        <label class="text-left fancy_radiochk_btn"> {{$t('proMszIAgree')}} <a :href="legalDocLink" target="_blank">{{$t('riskDisclaimer')}}</a>
                            <input type="checkbox" v-model="agree1" value="1"><span class="checkmark"></span>
                        </label>
                    </div>
                    <a href="#" class="underline mr-3" @click="show_step = 3">Back</a>
                    <a href="#" class="prism_btn btn_sm"  :class="(agree1 == '')? 'disabled' : ''" v-if="agree1 == ''"> {{$t('becomeAPro')}}</a>
                    <a href="#" class="prism_btn btn_sm" @click="req_otp()" :class="(agree1 == '')? 'disabled' : ''" v-else>{{$t('becomeAPro')}}</a>
                </div>
            </div>
			
		</div>

        <!---------------step5----------------------->
        <div class="mt-2 middleBox" v-if="trans_id != ''  && !congModule"> 
            <app-OptVerfication :transaction_id="trans_id" :module="reason" :data="'pro'" ></app-OptVerfication> 
        </div>

        <!---------------step6----------------------->
        <div class="mt-2 middleBox" v-if="congModule"> 
            <div class="row">
                <div class="col-12 whitebox p-4">
                    <div class="congratulations">
                        <div class="logo_congrats">
                            <img src="../../../../static/fxView/images/check.svg" alt="Icon">
                        </div>
                        <div class="subtitle">
                            <h3> {{$t('congo')}}<span class="green"> {{get_user.profile.firstname}} {{get_user.profile.lastname}}</span></h3> 
                            <p> {{$t('proMsz18')}}</p>
                        </div>
                    </div>
                    <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
                        <router-link :to="{ name: 'fxView.support', params: {tabName:'openRequest'}}" class="prism_btn">{{$t('proMsz19')}}</router-link>
                    </div>
                </div>  
            </div>
        </div> 
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import optVerfication from '../supports/services/otp_verification'
     import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    import moment from 'moment'
    export default {
        name: 'pro',
        mixins: [fxViewMixins],
        data() {
            return {
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                loaderFuncRun : '1',
                //==========================================
                congModule : false,
                trans_id : '',
                reason : '94',
                reason_text : 'Become A Pro',
                title : '',
                title_text : '',
                become_pro : false,
                show_step : 1 ,
                select_doc_type : [],
                document : [],
                agree : '',
                agree1 : '',
                formName : '',
                idtype: ['Passport', 'Driver License', 'National ID'],
                document_proof_array : {
                    'fin_trans' : '',
                    'fin_market': '',
                    'prof_exp': '',
                },
				id_type : '',
				l_name : '',
				f_name : '',
                document_file_array : {
                    'fin_trans' : [],
                    'fin_market': [],
                    'prof_exp': []
                },
				submittedRequest : false,
				errorMsz : '',
				errorMsz1 : '',
				
				submittedRequest1 : false,
            }
        },
        components: {
            appOptVerfication : optVerfication
        },
        methods:{
            onFileChange(getdocType , file) {
                // this.document_proof_array[getdocType] = file[0].name
                this.document_file_array[getdocType].push({
                    file: file[0],
                    name: file[0].name
                })
                document.getElementById(getdocType).value = '';
            },
            show_step_func(){
                if(this.select_doc_type.length >= 2){
                    this.show_step = 2
                    this.response_msg = ''
                    this.msg_type = ''
                }else{
                    this.response_msg = 'suceessMsz26'
                    this.msg_type = 'error'
                }
            },
            handleBack() {
                this.show_step = 2;
                this.response_msg = '';
                this.msg_type = '';
            },
            submitNow(){
                for (const element of this.select_doc_type) {
                    if(this.document_file_array[element].length == 0){
                        this.response_msg = 'Please upload all documents'
                        this.msg_type = 'error'
                        return
                    }
                }
				this.response_msg = ''
				this.msg_type = ''
				this.show_step = 4
				// let formRequest = document.getElementById('requestForm'); 
				// let form_name = new FormData(formRequest);
                let form_name = new FormData();
                
                for (const element of this.select_doc_type) {
                    this.document_file_array[element].forEach( item => {
                        if(item.name != ''){
                            form_name.append('document[]', item.file, element + '.'+ item.name.split('.')[item.name.split('.').length -1] )
                        }
                    });
                }
				let comment = 'Please change my categorisation to Pro'
				form_name.append("select_doc_type",this.select_doc_type);
				form_name.append("reason", this.reason);
				form_name.append("reason_text", this.reason_text);
				form_name.append("title", this.title);
				form_name.append("title_text", this.title_text);
				form_name.append("text",comment);
				form_name.append("type",'user');
			   
				this.formName = form_name
            },
            currentDate(){
                return moment().format('DD/MM/YYYY');
            },
            req_otp(){
				const _that = this
				this.submittedRequest = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
						if(this.getUserProfile.firstname.toLowerCase() != this.f_name.toLowerCase().trim()){
							this.errorMsz = 'First Name Mismatch'
							this.errorMsz1 = ''
						}else if(this.getUserProfile.lastname.toLowerCase() != this.l_name.toLowerCase().trim()){
							this.errorMsz1 = 'Last Name Mismatch'
							this.errorMsz = ''
						}
						/*else if(this.getUserProfile.P_IDNUMBER.toLowerCase() != this.id_type.toLowerCase().trim()){
                            this.errorMsz = this.idtype[this.getUserProfile['id_type']]+" mismatch"
                        }*/
                        else{
							this.errorMsz = ''
							this.errorMsz1 = ''
							let input_json={
								'globalParams' :{
									'form' : _that.formName
								},
								'localParams' :{ "parameter" : _that , 'module' : 'ticket-reply' ,'type' : 'pro' }
							}
							_that._runTicketRequestOtp(input_json)
						}
					}
                });
            }
        },
        created(){ 
            if(this.$store.getters[Const.GET_USER_PROFILE] != ''){
                this.loaderFuncRun = '0'
            }
            this._runGetUserProfile({'globalParams' :{},'localParams' :{ "parameter" : this , 'loaderFuncRun' : this.loaderFuncRun}})
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/pro.vue